import { z } from "zod";

const sortOrder = ["ascending", "descending"] as const;

/** Typed URL search for the rapporten overview list. */
export const rapportenOverviewSearchSchema = z.object({
  orderBy: z.string().catch("from").default("from"),
  orderDirection: z.enum(sortOrder).catch("descending").default("descending"),
});

/** Default values for rapporten search params; values not explicitly set will be omitted from URL. */
export const RAPPORTEN_OVERVIEW_SEARCH_DEFAULTS = {
  orderBy: "from",
  orderDirection: "descending" as const,
};

export type RapportenOverviewSearch = z.infer<typeof rapportenOverviewSearchSchema>;
